import { Outlet } from "react-router-dom";

const SalesProfileRight = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default SalesProfileRight;
